// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// console.log(router,'routerrouter')
Vue.config.productionTip = false
import './utils/flexible.js'
const $mc = {}
Vue.prototype.$mc = $mc
let vuexStore = require('@/store/$mc.mixin.js')
Vue.mixin(vuexStore.mcStore)
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/icon/iconfont.css'
import '@/assets/style/common.css'
import './assets/style/common.scss';

import VueCookies from 'vue-cookies';

import '@/utils/global' //全局
window.sessionStorage.clear()
import './promission' //这里进行路由后台获取的模拟
Vue.use(ElementUI);
Vue.use(VueCookies)
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
var BUS=new Vue();
Vue.prototype.BUS=BUS
import qs from 'qs'

Vue.prototype.$qs = qs
//===============================
//https://github.com/surmon-china/videojs-player/tree/vue-video-player
// import Vue from 'vue'
import VueVideoPlayer from 'vue-video-player'

// require videojs style
import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'

Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)
//===============================

import htmlToPdf from '@/utils/jspdf'
Vue.use(htmlToPdf)
// 在组件中可以调用this.getPdf(title, dom)方法导出


//引入Excel
import Blob from '@/utils/Blob'
import Export2Excel from '@/utils/Export2Excel.js'

import vButton from '@/components/Vbutton'
import vSelect from '@/components/Vselect'
import vSelect2 from '@/components/Vselect2'
import vInput from '@/components/Vinput'
Vue.component('v-button', vButton);
Vue.component('v-select', vSelect);
Vue.component('v-select2', vSelect2);
Vue.component('v-input', vInput);

import pattern from './utils/pattern.js'
Vue.prototype.$pattern  = pattern;
console.log("sdfffffffffff")
// 封装公共方法,导出Excel******************************************************
Vue.prototype.ExportExcel = function(list,tHeader,filterVal,name){
  // 导出数据
  this.list = list
  // 表头数据
  this.tHeader = tHeader
  // 表头数据对应名字
  this.filterVal = filterVal
  // 数据方法
  this.formatJson = function(filterVal, jsonData){
    return jsonData.map(v => filterVal.map(j => v[j]))
  }
  this.name = name
  // 导出文件的方法
  this.export2Excel = function(){
　　require.ensure([], () => {
　　　　const { export_json_to_excel } = require('@/utils/Export2Excel')
　　　　const tHeader = this.tHeader
　　　　const filterVal = this.filterVal
　　　　const list = this.list
        const name = this.name
　　　　const data = this.formatJson(filterVal, list)
　　　　export_json_to_excel(tHeader, data,name)
　　})
  }
}

new Vue({
  el: '#app',
  router,
  store: vuexStore.store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js